const productOffers = product => product.offers

export const minPriceOffer = product => {
    const offersWithPrices = productOffers(product).filter(offer => !!offerPriceAmount(offer))
    if (!offersWithPrices.length) return productOffers(product)[0]
    return offersWithPrices.sort((a, b) => offerPriceAmount(a) - offerPriceAmount(b))[0]
}

const offerPriceAmount = offer => (offer.notDeltaPrice || offer.price).amount

const numberAsc = (n1, n2) => n1 - n2
const numberDesc = (n1, n2) => n2 - n1

export const priceSort = (offer1, offer2, nuberSortFn) => {
    const price1 = offerPriceAmount(offer1)
    const price2 = offerPriceAmount(offer2)
    return price1 && price2 ? nuberSortFn(price1, price2) : price2 ? 1 : -1
}

export const offerPriceAsc = (offer1, offer2) => priceSort(offer1, offer2, numberAsc)
export const offerPriceDesc = (offer1, offer2) => priceSort(offer1, offer2, numberDesc)

export const priceAsc = (product1, product2) => offerPriceAsc(minPriceOffer(product1), minPriceOffer(product2))
export const priceDesc = (product1, product2) => offerPriceDesc(minPriceOffer(product1), minPriceOffer(product2))
